import { PromoteVariationTo } from 'chessboard/model/JCE-methods/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { MoveList } from 'chessboard/model/move-list/types';
import { canPromote } from 'src/shared/can-promote';
import type { ContextMenu } from '../config/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create the promote variation action
 */
export function createPromoteVariation(_store: Store, _storeActions: StoreActions) {
  return {
    getDisplayName: () => MoveList.Translation.Actions.Promote,
    action: CONTEXT_MENU_ACTION_NAMES.PromoteVariation,
    isVisible,
    handler,
  };

  /**
   * Check if `Promote` action should be available
   */
  function isVisible({ game, node }: ContextMenu.ActionHandlerContext) {
    return canPromote({ api: game, node });
  }

  /**
   * Promote a variation to the main line
   */
  function handler({ node, game }: ContextMenu.ActionHandlerContext): void {
    game.promoteVariation(node.ids.line, PromoteVariationTo.Parent);
  }
}
